module.exports = __webpack_public_path__ + "linea-weather-10.eef9b7d7918436513bec.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/linea/fonts/linea-weather-10.ttf
// module id = ../../../../../src/assets/linea/fonts/linea-weather-10.ttf
// module chunks = styles